/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SEOWebsitePage = lazyLoad(
  () => import('./index'),
  module => module.SEOWebsitePage
);
